import { ExternalOrderInfo } from "@api/throughShipment/externalOrderApi";

import React from "react";
import { Table, Typography } from "antd";

import calculatePieces from "../utils/calculatePieces";

const { Text } = Typography;

type Props = {
  externalOrderInfo: ExternalOrderInfo;
  externalOrdersRevenueLists: { requestQty: number }[];
  usePackageSet?: boolean;
};

export default function OrderSummaryTable({
  externalOrderInfo,
  externalOrdersRevenueLists,
  usePackageSet = false,
}: Props) {
  const dataSource = calculatePieces(
    externalOrderInfo.externalOrderLine,
    externalOrdersRevenueLists,
    usePackageSet,
  );

  return (
    <div style={{ width: "100%" }}>
      <Table
        columns={[
          {
            key: "key",
            dataIndex: "key",
            title: "合計",
            width: 100,
          },
          {
            key: "value",
            dataIndex: "value",
            render: (value: string | number) => <Text type="danger">{value}</Text>,
          },
        ]}
        dataSource={dataSource}
        pagination={false}
      />
    </div>
  );
}
